
import SmartToyIcon from '@mui/icons-material/SmartToy';

const EmptyBotList: React.FC = () => {
  return (
    <div
        style={{
          height: '100%',
          width: '100%',
          borderRadius: '12px',
          backgroundColor: '#fff',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '32px',
          textAlign: 'center',
          fontFamily: 'Montserrat',
        }}
      >
        <SmartToyIcon style={{ fontSize: 48, color: 'var(--primary)', marginBottom: 16 }} />
        <div style={{ fontSize: '20px', fontWeight: 600 }}>No assistants yet</div>
        <div style={{ fontSize: '16px', color: '#555' }}>Create one by pressing the "Create" button above.</div>
      </div>
  );
};

export default EmptyBotList